import { format, formatDistance, formatDistanceToNow, subSeconds } from 'date-fns';
import { de, enGB, enUS, es, fr, it, ru, uk, zhCN } from 'date-fns/locale';

export const currentLocale = navigator.language ?? 'en-GB';

export const mapDateLocal = (input: string) => {
	let locale;

	switch (input) {
		case 'en':
		case 'en-GB':
			locale = enGB;
			break;
		case 'en-US':
			locale = enUS;
			break;
		case 'de':
			locale = de;
			break;
		case 'fr':
			locale = fr;
			break;
		case 'it':
			locale = it;
			break;
		case 'es':
			locale = es;
			break;
		case 'uk':
			locale = uk;
			break;
		case 'ru':
			locale = ru;
			break;
		case 'zh-CN':
			locale = zhCN;
			break;
	}

	return locale;
};

export const getCurrentYear = () => {
	return new Date().getFullYear();
}

export const formatIsoDate = (input: number | string | Date, locale?: Locale) => {
	return format(new Date(input), 'yyyy-MM-dd', { locale: locale ?? mapDateLocal(currentLocale) });
};

export const formatIsoDateTime = (input: number | string | Date, locale?: Locale) => {
	return format(new Date(input), 'yyyy-MM-dd HH:mm:SS', { locale: locale ?? mapDateLocal(currentLocale) });
};

export const formatLocaleDate = (input: number | string | Date, locale?: Locale) => {
	return format(new Date(input), 'P', { locale: locale ?? mapDateLocal(currentLocale) });
};

export const formatLocaleDateTime = (input: number | string | Date, locale?: Locale) => {
	return format(new Date(input), 'Pp', { locale: locale ?? mapDateLocal(currentLocale) });
};

export const formatLocaleDateTimeMonthYear = (input: number | string | Date, locale?: Locale) => {
	return format(new Date(input), 'MMMM yyyy', { locale: locale ?? mapDateLocal(currentLocale) });
};

export const formatLocaleDateTimeLonger = (input: number | string | Date, locale?: Locale) => {
	return format(new Date(input), 'do MMMM yyyy, pp', { locale: locale ?? mapDateLocal(currentLocale) });
};

export const formatLocaleTime = (input: Date, locale?: Locale) => {
	return format(new Date(input), 'p', { locale: locale ?? mapDateLocal(currentLocale) });
};

export const formatStringMonthYear = (input: number | string | Date, locale?: Locale) => {
	return format(new Date(input), 'MMMM, yyyy', { locale: locale ?? mapDateLocal(currentLocale) });
};

export const formatLocaleRelative = (input: number | string | Date, locale?: Locale) => {
	return formatDistance(new Date(input), new Date(), { locale: locale ?? mapDateLocal(currentLocale), addSuffix: true });
};

export const formatLocaleTimeSince = (input: number | string | Date, locale?: Locale) => {
	const startDate = subSeconds(new Date(), input as number);
	return formatDistanceToNow(startDate, { locale: locale ?? mapDateLocal(currentLocale) });
};